const headerData = [
    {
      prop: 'id',
      label: '序号',
      columnwidth: 50
    },
    {
      prop: 'InvCode',
      label: '产品编码',
      columnwidth: 120
    },
    {
      prop: 'InvAddCode',
      label: '产品代码',
      columnwidth: 180
    },
    {
      prop: 'InvClassName',
      label: '产品线',
      columnwidth: 70
    },
	{
		prop: 'HospitalName',
		label: '仓库',
		columnwidth: 70
	},
    {
      prop: 'InvName',
      label: '产品名称',
      columnwidth: 200
    },
    {
      prop: 'WHName',
      label: '经销商名称',
      columnwidth: 220
    },
    {
      prop: 'Batch',
      label: '批号',
      columnwidth: 100
    },
    {
      prop: 'ValiDate',
      label: '有效期',
      columnwidth: 130
    },
    {
      prop: 'Quantity',
      label: '数量',
      columnwidth: 150
    },
    {
      prop: 'UnitName',
      label: '单位',
      columnwidth: 100
    },
    {
      prop: 'FUnitName',
      label: '辅助计量单位',
      columnwidth: 130
    },
    {
      prop: 'FQuantity',
      label: '辅助单位数量',
      columnwidth: 130
    },
    {
      prop: 'LEVEL1',
      label: 'LEVEL1',
      columnwidth: 120
    },
    {
      prop: 'LEVEL2',
      label: 'LEVEL2',
      columnwidth: 120
    },
    {
      prop: 'LEVEL3',
      label: 'LEVEL3',
      columnwidth: 120
    },
    {
      prop: 'LEVEL4',
      label: 'LEVEL4',
      columnwidth: 120
    },
    {
      prop: 'StandardCost',
      label: '参考单价',
      columnwidth: 80
    },
    {
      prop: 'Total',
      label: '参考价合计',
      columnwidth: 95
    },
  ]
  export default headerData;